import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-ab-time',
  templateUrl: './ab-time.component.html',
  styleUrls: ['./ab-time.component.scss']
})
export class AbTimeComponent implements OnInit {

 @Input() element: any;
  constructor() { }

  ngOnInit(): void {
  }

}
